import React from 'react'
import { StyleProp, TextStyle, View, ViewStyle } from 'react-native'
import { useTheme } from '@ui-kitten/components'
import { StyleService, useStyleSheet } from '@src/style/service'
import { Button, Text } from '@src/components/base'
import { EhrAppointmentKind } from '@src/types'
import { useVideoCallDurations } from '@screens/NutritionistHub/hooks/useVideoCallDurations.ts'
import { useIsDarkMode } from '@src/config/theme'
import CallDuration from './CallDuration'

export interface SuggestedCallCardProps {
  meetingAt: string
  coachName?: string | null
  appointmentKind?: EhrAppointmentKind
  label: string
  title?: string | null
  style?: StyleProp<ViewStyle>
  textStyle?: StyleProp<TextStyle>
  schedulingDisabled?: boolean
  onSchedulePress: () => void
}

export const SuggestedCallCard = ({
  meetingAt,
  coachName,
  appointmentKind,
  label,
  title,
  style,
  onSchedulePress,
  schedulingDisabled,
}: SuggestedCallCardProps) => {
  const styles = useStyleSheet(themedStyles)
  const { getAppointmentDuration } = useVideoCallDurations()

  const isDarkMode = useIsDarkMode()
  const theme = useTheme()

  const duration = getAppointmentDuration(appointmentKind)

  return (
    <View style={[styles.container, style]}>
      <View style={[styles.titleRow, styles.titleRowSmallMargin]}>
        <View>
          <View>
            <Text
              type="regular"
              style={{
                color: isDarkMode ? theme['theme.info.light_'] : theme['theme.info.darkest'],
              }}
            >
              {label}
            </Text>
          </View>

          {!!title && (
            <View style={styles.titleWrapper}>
              <Text
                type="regular"
                bold
                style={{
                  ...styles.titleText,
                  width: 'auto',
                }}
              >
                {title}
              </Text>
            </View>
          )}
        </View>

        <Button
          accessibilityLabel="Book Suggested Call"
          type="primary"
          size="small"
          onPress={onSchedulePress}
          disabled={schedulingDisabled}
          style={styles.confirmButton}
        >
          Confirm
        </Button>
      </View>

      <CallDuration coachName={coachName} meetingAt={meetingAt} large={false} duration={duration} />
    </View>
  )
}

const themedStyles = StyleService.create({
  container: {
    borderColor: 'theme.info.base',
    borderLeftWidth: 3,
    paddingLeft: 12,
  },
  row: {
    flexDirection: 'row',
    paddingBottom: 10,
  },
  titleRow: {
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    flexDirection: 'row',
    marginBottom: 16,
    width: '100%',
  },
  titleRowSmallMargin: {
    marginBottom: 6,
  },
  titleWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    display: 'flex',
    gap: 8,
  },
  titleText: {
    color: 'theme.text.primary',
  },
  confirmButton: {
    marginLeft: 'auto',
  },
})
